import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getQueueCount = {
  name: "getQueueCount" as const,
  input: z.object({ teamId: zExt.objectId().optional() }),
  output: z.object({ count: z.number() }),
};
